<mat-toolbar class="bar-filler"></mat-toolbar>
<div class="small-margin small-padding">
    <div class="label">{{'Pages.OrderBaseData.Schedule' | translate}}</div>
    <div class="flex-container-center list-cell" (click)="setScheduled(false)">
        <div mat-ripple [ngClass]="{'cell-switch-filled':scheduled === false, 'cell-switch':scheduled === true}"></div>
        <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.DoItNow' | translate}}</div>
    </div>
    <div class="flex-container-center list-cell" (click)="setScheduled(true)">
        <div mat-ripple [ngClass]="{'cell-switch-filled':scheduled === true, 'cell-switch':scheduled === false}"></div>
        <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.DoItLater' | translate}}</div>
    </div>
    <div *ngIf="scheduled === true">
        <div style="height: 10px;"></div>
        <mat-form-field>
            <mat-label>{{'Pages.OrderBaseData.ScheduleFor' | translate}}</mat-label>
            <input matInput type="time" name="scheduleTime" [(ngModel)]="scheduletime">
        </mat-form-field>
    </div>
</div>
<mat-divider></mat-divider>
<div *ngIf="ordermode === 2 || ordermode === 4">
    <div>
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderBaseData.PaymentMode' | translate}}</div>
            <div class="flex-container-center list-cell" (click)="setPaymode(0)">
                <div mat-ripple [ngClass]="{'cell-switch-filled':paymode === 0, 'cell-switch':paymode === 1 || paymode === -1}"></div>
                <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.Money' | translate}}</div>
            </div>
            <div class="flex-container-center list-cell" (click)="setPaymode(1)">
                <div mat-ripple [ngClass]="{'cell-switch-filled':paymode === 1, 'cell-switch':paymode === 0  || paymode === -1}"></div>
                <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.Card' | translate}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="paymode === 0">
        <div class="small-margin small-padding">
            <div class="label">{{'Pages.OrderBaseData.Change' | translate}}</div>
            <div class="flex-container-center list-cell" (click)="setNeedsChange(0)">
                <div mat-ripple [ngClass]="{'cell-switch-filled':needschange === 0, 'cell-switch':needschange === 1 || needschange === -1}"></div>
                <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.NoChange' | translate}}</div>
            </div>
            <div class="flex-container-center list-cell" (click)="setNeedsChange(1)">
                <div mat-ripple [ngClass]="{'cell-switch-filled':needschange === 1, 'cell-switch':needschange === 0 || needschange === -1}"></div>
                <div class="list-cell-label small-padding block">{{'Pages.OrderBaseData.NeedsChange' | translate}}</div>
            </div>
        </div>
    </div>
    <div *ngIf="paymode === 0 && needschange === 1">
        <div class="small-margin small-padding">
            <mat-form-field>
                <div style="height: 10px;"></div>
                <mat-label>{{'Pages.OrderBaseData.ChangeFor' | translate}}</mat-label>
                <input matInput type="number" name="changeamount" [(ngModel)]="changefor">
            </mat-form-field>
        </div>
    </div>
    <mat-divider></mat-divider>
</div>
<mat-toolbar class="bar-filler">
    <mat-toolbar-row>
        <P></P>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <P></P>
    </mat-toolbar-row>
</mat-toolbar>
<mat-toolbar color="primary" class="top-bar">
    <button mat-icon-button (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div>{{'Pages.OrderBaseData.Title' | translate}}</div>
</mat-toolbar>
<mat-toolbar class="bottom-bar" color="primary">
    <mat-toolbar-row>
        <div class="big-price-text">{{currentPriceString}}</div>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <button mat-flat-button color="accent" (click)="goOn()" class="fill-parent-width">{{'Pages.OrderBaseData.Confirm' | translate}}</button>
    </mat-toolbar-row>
</mat-toolbar>